export const getMaxHeightIncludingChildren = (container) => {
  if (!container || !container.children) {
    return 0;
  }

  const containerHeight = container.offsetHeight;
  const children = Array.from(container.children);

  if (children.length === 0) {
    return containerHeight;
  }

  const maxChildHeight = children.reduce((max, child) => {
    const height = child.offsetHeight;
    return height > max ? height : max;
  }, 0);

  return Math.max(containerHeight, maxChildHeight);
};
